import React from "react";

function ProgressDots(props) {
    return (
       <div className={props.className ? props.className : ""} >
           <svg
                className={props.svgClass ? props.svgClass : ""}
                height={props.height ? props.height : "20px"}
                xmlns="http://www.w3.org/2000/svg"
                fillRule="evenodd"
                strokeLinejoin="round"
                strokeMiterlimit="2"
                clipRule="evenodd"
                viewBox="0 0 5 44"
           >
               {/* <path
                   className={props.pathClass ? props.pathClass : ""}
                   fill={props.color ? props.color : "black"}
                   //
               ></path> */}
            <circle
                fill={props.progress === 1 ? "#4b5cf7" : "#DFDFE2"}
                cx="8049.19"
                cy="1865.28"
                r="2.273"
                transform="translate(-8046.91 -1863)"
            ></circle>
            <circle
                fill={props.progress === 2 ? "#4b5cf7" : "#DFDFE2"}
                cx="8049.19"
                cy="1865.28"
                r="2.273"
                transform="translate(-8046.91 -1850.11)"
            ></circle>
            <circle
                fill={props.progress === 3 ? "#4b5cf7" : "#DFDFE2"}
                cx="8049.19"
                cy="1865.28"
                r="2.273"
                transform="translate(-8046.91 -1837.22)"
            ></circle>
            <circle
                fill={props.progress === 4 ? "#4b5cf7" : "#DFDFE2"}
                cx="8049.19"
                cy="1865.28"
                r="2.273"
                transform="translate(-8046.91 -1824.33)"
            ></circle>
            </svg>
       </div>
    );
}

export default ProgressDots;